'use client';
import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import { Button } from '@/components/common/Button';
import { useAuthContext } from '@/contexts/auth';
import { useRouter } from 'next/navigation';

export const AnonymousProfile = () => {
	const router = useRouter();
	const { user } = useAuthContext();
	const { t } = useTranslation();

	const redirectLoginPage = () => {
		router.push('/my_profile/login');
	};

	return (
		<div className="flex flex-col items-center gap-y-4">
			<div className="flex flex-col items-center gap-y-2.5">
				<img
					src={user?.avatar ? user.avatar : '/images/user.png'}
					className="w-15 h-15 rounded-full object-center"
					alt="avatar"
				/>

				<div className="text-xl font-bold text-center">{user?.fullName}</div>
			</div>
			<div className="flex flex-col items-center  gap-y-5">
				<div className="text-grey-1 text-center">
					{t('common:loginToDiscover')}
				</div>
				<Button variant="dark" onClick={redirectLoginPage}>
					{t('common:loginNow')}
				</Button>
			</div>
		</div>
	);
};
